import {
  AppointmentCardDataSchema,
  CareAdvocateCallbackPickerDataSchema,
  CareAdvocateCallbackSlotPickerDataSchema,
  CoveredProceduresWidgetDataSchema,
  ProviderListDataSchema,
} from "@/types"

import { AppointmentCard } from "./AppointmentCard"
import { CareAdvocateCallbackPicker } from "./CareAdvocateCallbackPicker"
import { CareAdvocateCallbackSlotPicker } from "./CareAdvocateCallbackSlotPicker"
import { CoveredProceduresWidget } from "./CoveredProceduresWidget"
import { ProviderList } from "./DoctorCard"
import { WidgetRegistry } from "./WidgetRegistry"

/**
 * Register the widget types this app can render, each keyed by the
 * `widget_type` value a widget stream event arrives with. An unregistered type
 * renders as a FallbackWidget.
 */
function registerBuiltInWidgets(registry: WidgetRegistry): void {
  registry.register("provider-list", ProviderList, ProviderListDataSchema)

  // TODO: implement cost compare widget and register here

  registry.register(
    "appointment-card",
    AppointmentCard,
    AppointmentCardDataSchema,
  )

  registry.register(
    "covered-procedures-table",
    CoveredProceduresWidget,
    CoveredProceduresWidgetDataSchema,
  )

  registry.register(
    "careadvocate-callback-slot-picker",
    CareAdvocateCallbackSlotPicker,
    CareAdvocateCallbackSlotPickerDataSchema,
  )

  registry.register(
    "careadvocate-callback-picker",
    CareAdvocateCallbackPicker,
    CareAdvocateCallbackPickerDataSchema,
  )
}

/** A registry holding every widget type this app can render. */
export function createWidgetRegistry(): WidgetRegistry {
  const registry = new WidgetRegistry()
  registerBuiltInWidgets(registry)
  return registry
}

// The registry the app renders widgets from
export const widgetRegistry = createWidgetRegistry()
